import { render, staticRenderFns } from "./Ideasoft.vue?vue&type=template&id=1cdfb288&scoped=true"
import script from "./Ideasoft.vue?vue&type=script&lang=js"
export * from "./Ideasoft.vue?vue&type=script&lang=js"
import style0 from "./Ideasoft.vue?vue&type=style&index=0&id=1cdfb288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdfb288",
  null
  
)

export default component.exports